/** Loading placeholder for a read-only tab's grid — skeleton rows, never a spinner over
 *  content. */
import { Box, Skeleton } from '@mui/material';

export function TabSkeleton({ rows = 4, label }: { rows?: number; label: string }) {
  return (
    <Box role="status" aria-label={label} sx={{ display: 'grid', gap: 0.75 }}>
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} variant="rounded" height={28} />
      ))}
    </Box>
  );
}
